"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Footer;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _FooterModule = _interopRequireDefault(require("./Footer.module.scss"));

var _Button = _interopRequireDefault(require("../../../../../inputElements/Button/Button"));

var _EButtonType = _interopRequireDefault(require("../../../../../inputElements/Button/EButtonType"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Footer(_ref) {
  var _ref$availableSkillPo = _ref.availableSkillPoints,
      availableSkillPoints = _ref$availableSkillPo === void 0 ? 0 : _ref$availableSkillPo,
      onClickSkillUp = _ref.onClickSkillUp,
      _ref$hideSkillUpButto = _ref.hideSkillUpButton,
      hideSkillUpButton = _ref$hideSkillUpButto === void 0 ? false : _ref$hideSkillUpButto,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_FooterModule.default.footer, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _FooterModule.default.remainingPts
  }, availableSkillPoints), !hideSkillUpButton && /*#__PURE__*/_react.default.createElement("div", {
    className: _FooterModule.default.skillUpBtn
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.SKILL_UP,
    onClick: function onClick() {
      if (onClickSkillUp) onClickSkillUp();
    }
  })));
}